import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { baseurl,imageUrl } from "../../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const EditAssignee = () => {
  const { id } = useParams(); // Get the assignee ID from route params

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [department, setDepartment] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [existingImage, setExistingImage] = useState("");
const navigate = useNavigate();

  // Handle dropped file
  const handleDrop = (acceptedFiles) => {
    setProfileImage(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: "image/*",
  });

  const adminID = localStorage.getItem("adminID");

  useEffect(() => {
    const fetchAssignee = async () => {
      try {
        const response = await axios.get(`${baseurl}getAssigneeById/${id}`);
        const data = response.data.assignee;
        setFullName(data.full_name || "");
        setEmail(data.email || "");
        setRole(data.role || "");
        setDepartment(data.department || "");
        setExistingImage(data.profile_image || "");
      } catch (error) {
        toast.error("Error fetching assignee data.");
        console.error("Fetch error:", error);
      }
    };

    if (id) fetchAssignee();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", fullName);
    formData.append("email", email);
    formData.append("role", role);
    formData.append("department", department);
    formData.append("adminId", adminID);
    if (profileImage) {
      formData.append("profileImage", profileImage);
    }

    try {
      const response = await axios.post(`${baseurl}updateAssigneeById/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Assignee updated successfully!");
      setTimeout(() => {
        // window.location.reload();
        navigate(-1);
      }, 2000);
    } catch (error) {
      console.error("Error updating assignee", error);
      toast.error("Error updating assignee. Please try again.");
    }
  };

  return (
    <>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Assignee</h5>
          </div>
          <div className="modal-body text-start">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="">Select Role</option>
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="developer">Developer</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Department</label>
                <select
                  className="form-select"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                >
                  <option value="">Select Department</option>
                  <option value="engineering">Engineering</option>
                  <option value="sales">Sales</option>
                  <option value="hr">HR</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Profile Image</label>
                <div
                  {...getRootProps({
                    className: "profile-image-upload-box",
                    style: {
                      border: "2px dashed #ddd",
                      padding: "20px",
                      textAlign: "center",
                      cursor: "pointer",
                    },
                  })}
                >
                  {profileImage ? (
                    <div>
                      <img
                        src={URL.createObjectURL(profileImage)}
                        alt="profile preview"
                        style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                      />
                      <p>{profileImage.name}</p>
                    </div>
                  ) : existingImage ? (
                    <div>
                      <img
                        src={`${imageUrl}assignee/${existingImage}`}
                        alt="current profile"
                        style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                      />
                      <p>{existingImage}</p>
                    </div>
                  ) : (
                    <p>Drag & Drop or Click to Select Profile Image</p>
                  )}
                  <input {...getInputProps()} hidden />
                </div>
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  Update Assignee
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer position="top-center" autoClose={5000} theme="colored" />
      </div>
    </>
  );
};

export default EditAssignee;
